"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
function SwitchBox(props) {
    var checked = props.checked, onToggle = props.onToggle, name = props.name;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = __read(react_1.default.useState(true), 2), withoutAnimation = _a[0], setWithoutAnimation = _a[1];
    // to disable animation when the component is rerendered
    var disableAnimation = function () {
        setTimeout(function () {
            setWithoutAnimation(true);
        }, 800);
    };
    return (react_1.default.createElement("div", { className: "eva-switch-box" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('eva-switch-box__value', { 'eva-switch-box__value--checked': checked, 'no-animation': withoutAnimation }), "data-cy": name && "switch_box_".concat(name), onClick: function () {
                setWithoutAnimation(false);
                onToggle(!checked);
                disableAnimation();
            } },
            react_1.default.createElement("div", { className: "eva-switch-box__on" },
                react_1.default.createElement("div", { className: "eva-switch-box__text" }, t('COMMON.CHECKBOX.ON')),
                react_1.default.createElement("div", { className: "eva-switch-box__circle" })),
            react_1.default.createElement("div", { className: "eva-switch-box__off" },
                react_1.default.createElement("div", { className: "eva-switch-box__circle" }),
                react_1.default.createElement("div", { className: "eva-switch-box__text" }, t('COMMON.CHECKBOX.OFF'))))));
}
exports.default = SwitchBox;
